/**
 * Кто есть кто в Telegram — со стороны сайта.
 *
 * То же разделение, что и на сервере: игровой бот про викторины, бот курсов про
 * обучение. Пока у курсов своего бота нет, имя совпадает с игровым и ничего не
 * ломается. Появится — задать VITE_COURSES_BOT при сборке (или поправить строку
 * ниже) и пересобрать сайт.
 */

export const GAMES_BOT = import.meta.env.VITE_GAMES_BOT || 'qwizmug_bot';
export const COURSES_BOT = import.meta.env.VITE_COURSES_BOT || GAMES_BOT;

export function gamesBotUrl(payload?: string): string {
  return `https://t.me/${GAMES_BOT}` + (payload ? `?start=${payload}` : '');
}

/** Ссылка в бота курсов; payload — то, что бот получит в /start. */
export function coursesBotUrl(payload?: string): string {
  return `https://t.me/${COURSES_BOT}` + (payload ? `?start=${payload}` : '');
}
